<template>
  <div class="page page__list">
    <search-bar
      @search="onSearch"
      name="pr_code,pr_detail,pr_orispeccode,pr_spec"
      placeholder="输入物料编号、名称、型号/规格"
      ref="searchBar"
    />
    <scroll-list @refresh="onSearch" @loadpage="onSearchNext">
      <router-link
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        :to="'/production/bom_composite/'+item.pr_code"
      >
        <div class="weui-cell__bd">
          <p>{{item.pr_detail}}</p>
          <p class="list-item-muted" v-if="item.pr_orispeccode">{{item.pr_orispeccode}}</p>
          <p class="list-item-muted" v-else>{{item.pr_spec}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.pr_code}}</p>
        </div>
      </router-link>
    </scroll-list>
  </div>
</template>

<script>
import SearchBar from "@/components/SearchBar.vue";
import ScrollList from "@/components/ScrollList.vue";
import list from "@/mixins/list.js";

export default {
  components: {
    SearchBar,
    ScrollList
  },
  mixins: [list],
  data() {
    return {
      listUrl: "/api/document/product/list",
    };
  }
}
</script>